<form class="example-form">
  <mat-form-field fxFlex class="example-full-width" appearance="outline">
    <span matPrefix *ngIf="showIcon"><mat-icon>search</mat-icon></span>
    <input
      #searchInput
      name="search-field"
      class="uppercase"
      matInput
      placeholder={{placeHolder}}
      [(ngModel)]="search"
      (keyup)="onChange.emit({ filter: search, event: $event })"
      autocomplete="off"
      (focus)="keyboardService.onInputFocus(keyboardChange, $event)"
      (ngModelChange)="keyboardService.onInputChange(search, searchInput)"
    />
    <button
      *ngIf="search"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      (click)="clear()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</form>
